var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5443",
    "data-name": "Group 5443",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.964,
    height: 31.059,
    viewBox: "0 0 21.964 31.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M18.75,3.217A10.97,10.97,0,0,0,1.44,16.384c.008.02.017.039.026.058L10.4,30.71a.657.657,0,0,0,1.16,0L20.5,16.442a.585.585,0,0,0,.029-.066A10.931,10.931,0,0,0,18.75,3.217",
    fill: "#1967D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M12.743,5.985H11.431V4.018a.658.658,0,0,0-.656-.656H8.153a.658.658,0,0,0-.656.656V5.985H6.186A1.315,1.315,0,0,0,4.875,7.3v7.212a1.315,1.315,0,0,0,1.311,1.311.656.656,0,1,0,1.311,0h3.934a.656.656,0,1,0,1.311,0,1.315,1.315,0,0,0,1.311-1.311V7.3a1.315,1.315,0,0,0-1.311-1.311M7.825,13.852H6.842v-5.9h.983Zm2.131,0H8.973v-5.9h.983Zm.492-7.868H8.481V4.345h1.967Zm1.639,7.868H11.1v-5.9h.983Z",
    transform: "translate(1.518 1.047)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelActive);
export default __webpack_public_path__ + "static/media/hotel-active.4f4c6980e8e203c12157d1842699f5c2.svg";
export { ForwardRef as ReactComponent };